import { Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { z } from 'zod';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { TextField } from 'targets/web/components';
export const SpecialServiceNotesSchema = z.object({
  specialServiceNote: z.string().optional(),
});

export type SpecialServiceNotesData = z.infer<typeof SpecialServiceNotesSchema>;

const TEXT_LIMIT = 250;

export interface NotesProps {
  disabled?: boolean;
}
const SpecialServiceNotesField: FC<NotesProps> = ({ disabled }) => {
  const { values, handleChange } = useFormikContext<SpecialServiceNotesData>();
  const t = useTranslationPrefix('customer_portal.request_service_modal');
  return (
    <Stack spacing={4}>
      <TextField
        label={t('special_service_notes_label')}
        placeholder={t('special_service_notes_placeholder')}
        name="specialServiceNote"
        value={values.specialServiceNote}
        fullWidth
        multiline
        rows={4}
        inputProps={{ maxLength: TEXT_LIMIT }}
        disabled={disabled}
        onChange={handleChange('specialServiceNote')}
      />
      <Typography variant="inputHelper">{t('special_service_notes_helper')}</Typography>
    </Stack>
  );
};

export default SpecialServiceNotesField;
